import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";

export default function Master() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [date, setDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [remark, setRemark] = useState(null);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [showModal, setShowModal] = useState(false);
  const [editUser, setEditUser] = useState({});

  useEffect(() => {
    http.get(`/category`).then((res) => {
      setdepartments(res.data.data);
    });
    fetchTaskDetails();
  }, []);

  const fetchTaskDetails = () => {
    setIsLoading(true);
    let endpoint = `/master`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const handleSave = async (taskId) => {
    if (currentStatus === null || taskId === null) {
      toast.error("Please select proper status");
      return true;
    }
    try {
      const response = await http.put(
        `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails();
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Please select proper item");
    }
  };

  const [formData, setFormData] = useState({
    revised_date: "",
    revised_remark: "",
  });
  const initialState = {
    revised_date: "",
    revised_remark: "",
  };

  const handleChangeModal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const deleteTask = async (taskId) => {
    console.log(taskId);
    await http
      .delete(`/master_del/${taskId}`)
      .then((response) => {
        toast.success("Master Deleted successfully !");
        fetchTaskDetails();
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const openEditModal = (user) => {
    setShowModal(true);
    setFormData({
      vendor: user.vendor || "",
      cat_id: user.cat_id || "",
      suplier: user.suplier || "",
      price: user.price || "",
      mrp: user.mrp || "",
      item_name: user.item_name || "",
    });
    setEditUser(user);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const saveEditedUser = async (e) => {
    e.preventDefault();
    try {
      if (!editUser) {
        // Handle the case when editUser is null
        console.error("No user data to edit.");
        return;
      }

      const response = await http.put(`/master_edit/${editUser.id}`, formData);
      if (Array.isArray(response.data.data)) {
        toast.success("Master data updated successfully!");
        setShowModal(false);
        fetchTaskDetails();
      } else {
        console.log("API response is not an array");
      }
    } catch (error) {
      console.error("Error updating user", error);
      toast.error("An error occurred while updating the customer.");
    }
  };

  return (
    <>
      <Toaster />
      {showModal && (
        <form onSubmit={saveEditedUser}>
          <div className="modal" tabindex="-1" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Masters Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group  mt-3">
                    <label> Item Name </label>
                    <input
                      name="item_name"
                      required
                      className="form-control"
                      type="text"
                      value={formData.item_name}
                      onChange={handleChangeModal}
                    />
                  </div>

                  <div className="form-group  mt-3">
                    <label>Category</label>
                    <select
                      onChange={handleChangeModal}
                      name="cat_id"
                      className="form-control mb-1"
                      value={formData.cat_id}
                      required
                    >
                      {departments.map((dept, index) => (
                        <option key={index} value={dept.id}>
                          {dept.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group  mt-3">
                    <label>supplier</label>
                    <input
                      name="suplier"
                      required
                      className="form-control"
                      type="text"
                      value={formData.suplier}
                      onChange={handleChangeModal}
                    />
                  </div>

                  <div className="form-group  mt-3">
                    <label>Price</label>
                    <input
                      name="price"
                      required
                      className="form-control"
                      type="text"
                      value={formData.price}
                      onChange={handleChangeModal}
                    />
                  </div>

                  <div className="form-group  mt-3">
                    <label>Vendor</label>
                    <input
                      name="vendor"
                      required
                      className="form-control"
                      type="text"
                      value={formData.vendor}
                      onChange={handleChangeModal}
                    />
                  </div>

                  <div className="form-group  mt-3">
                    <label>MRP</label>
                    <input
                      name="mrp"
                      required
                      className="form-control"
                      type="text"
                      value={formData.mrp}
                      onChange={handleChangeModal}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      <div className="container mt-1">
        <div className="row">
          <h1>Masters</h1>
          {user.department_id === 1 && (
            <Link className="btn-link  text-end mb-3" to="/jobcart/master_add">
              Add Master
            </Link>
          )}
        </div>

        <div className="table-responsive">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th className="text-danger">No</th>
                  <th>Item Name</th>
                  <th>Category</th>
                  <th>Supplier</th>
                  {user.department_id === 1 && <th>Price</th>}

                  <th>MRP</th>
                  <th>Action</th>

                  {/* Add other fields as necessary */}
                </tr>
              </thead>
              <tbody>
                {tasks.map((taskuser, index) => (
                  <tr key={taskuser.id}>
                    <td>{index + 1}</td>
                    <td>{taskuser.item_name}</td>
                    <td>{taskuser.category?.name}</td>
                    <td>{taskuser.suplier}</td>
                    {user.department_id === 1 && <td>{taskuser.price}</td>}

                    <td>{taskuser.mrp}</td>
                    <td>
                      {user.department_id == 1 && (
                        <button
                          className="btn btn-link"
                          onClick={() => {
                            if (
                              window.confirm(
                                "Are you sure you want to delete this master?"
                              )
                            ) {
                              deleteTask(taskuser.id);
                            }
                          }}
                        >
                          Delete
                        </button>
                      )}
                      <button
                        className="btn  btn-sm btn-link"
                        onClick={() => openEditModal(taskuser)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
